import { render, staticRenderFns } from "./PSF.vue?vue&type=template&id=f46e62fa"
import script from "./PSF.vue?vue&type=script&lang=js"
export * from "./PSF.vue?vue&type=script&lang=js"
import style0 from "./PSF.vue?vue&type=style&index=0&id=f46e62fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports